import React from "react";
import "./Divider.scss"

function Divider(props) {
  return (
    <div className="dividerContainer">
      <div className="dividerBorder" />
      <span className="dividerContent">{props.text}</span>
      <div className="dividerBorder" />
    </div>
  );
}

export default Divider;
